import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import Image from '@atlaskit/image';

import CalendarDark from '../assets/calendar-dark.svg';
import CalendarLight from '../assets/calendar-light.svg';
import { StandardActionsKnowledgeCard } from '../standard-cards/StandardActionsKnowledgeCard';

const messages = defineMessages({
	knowledge_card_date_category: {
		id: 'search_ai_knowledge_card_date_category',
		defaultMessage: 'Date',
		description: 'Category header for date knowledge card',
	},
});

export const DateCard = ({ date }: { date: string }) => {
	const { formatMessage } = useIntl();

	return (
		<StandardActionsKnowledgeCard
			name="smart-answer-date-knowledge-card"
			category={formatMessage(messages.knowledge_card_date_category)}
			primaryDescription={date}
			media={<Image src={CalendarLight} srcDark={CalendarDark} />}
			size="full"
		/>
	);
};
